import {Box, Text} from '@chakra-ui/react';
import {useEffect} from 'react';
import {useRouter} from 'next/router';
import {PageLayout} from '../components/global/page-layout';
import {useUserQuery} from '../graphql/generated';
import {useAppToast} from '../hooks/app-toast';
import {Routes} from '../shared/consts';
import {ResetPasswordController} from '../components/auth/reset-password-controller';

const ResetPasswordPage: React.FC = () => {
  const userQuery = useUserQuery();
  const toast = useAppToast();
  const router = useRouter();

  useEffect(() => {
    if (userQuery.data?.user) {
      toast.showErrorToast(
        'We were unable to complete your request because you’re already logged in',
        'You’re already signed in!',
      );
      router.replace('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userQuery.data?.user]);

  return (
    <PageLayout firstName={userQuery.data?.user?.firstName}>
      <Box
        flexDir="column"
        textAlign="center"
        color="charcoal"
        mb={14}
        px={2}
        alignItems="center"
      >
        <Text
          textStyle={{base: 'h5', md: 'h3'}}
          as="h3"
          px={4}
          color="darkGrey"
        >
          Reset password
        </Text>
      </Box>
      <Box width="100%" maxW="528px" margin="0 auto">
        <ResetPasswordController
          trackingNamePrefix="Reset password"
          maxSteps={3}
          onPasswordReset={() => {
            router.replace(Routes.LOGIN);
          }}
        />
      </Box>
    </PageLayout>
  );
};

export default ResetPasswordPage;
